export default {
    FEE_TYPE: {
        1: '免费',
        2: '收费'
    },
    AUTH_TYPE: {
        1: '无需授权',
        2: '需要授权'
    }
};
